import * as S from "components/common/Banner/Overlay.style"

const Overlay = () => {
    return (
        <>
            <S.Overlay>
                <S.TextBanner variant="headline-01" color="white">
                    <S.MainInfo>
                        Área exclusiva de imprensa
                    </S.MainInfo>
                </S.TextBanner>
                <S.TextBanner variant="headline-01" color="white">
                    <S.SecondaryInfo>
                        Bem-vindo à área exclusiva de relacionamento com profissionais da imprensa.
                    </S.SecondaryInfo>
                </S.TextBanner>
                <S.BannerIndicator />
            </S.Overlay>
        </>
    );
};

export default Overlay;